var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardListTagClose = function SvgNewcsDashboardListTagClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_list_tag_close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M139 437.973h8v8h-8z",
    "data-name": "\\u77E9\\u5F62 462"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_list_tag_close_svg__a)",
    transform: "translate(-139 -437.973)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#38b16a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m143 441.973-3.25 3.25zl-3.25-3.25zl3.25-3.25zl3.25 3.25Z",
    "data-name": "\\u8054\\u5408 65"
  }))));
};
export default SvgNewcsDashboardListTagClose;